import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCart,
  verifyCheckoutSession,
  verifyStripeCheckout,
} from "../../../../_actions/cart.actions";
import { Success } from "./Success/Success";
import { Failure } from "./Failure/Failure";
import { Loading } from "../../../Other/Loading";
import "./checkout.scss";
import { useNavigate } from "react-router-dom";

export const Checkout = ({ history }) => {

  const navigate=useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.users);
  var { isProcessing, isSuccess } = useSelector((state) => state.cart);
  const [paymentMethod, setPaymentMethod] = useState(null);

  useEffect(() => {

    const urlParams = new URLSearchParams(window.location.search);
    const paymentId = urlParams.get('payment_id')

    dispatch(fetchCart());
    var checkoutData = localStorage.getItem("checkout-data");
    
    if (checkoutData === null) {
      const chekoutSession = localStorage.getItem("ck_session")
        ? JSON.parse(localStorage.getItem("ck_session"))
        : null;
      if (chekoutSession) {
        dispatch(
          verifyCheckoutSession(
            chekoutSession.session,
            chekoutSession.country_code,
            chekoutSession?.enterpriseStatus,
            paymentId 
          )
        );
      } 
      // else {
      //   navigate("/cart");
      // }
    } else {
      dispatch(verifyStripeCheckout());
      localStorage.removeItem("checkout-data");
      checkoutData = JSON.parse(checkoutData);
    }
  }, []);

  return (
    <div className="checkout-container">
      {user && (
        <div className="checkout-header">{user.userName}'s Shopping Cart</div>
      )}
      {isProcessing ? <Loading /> : isSuccess ? <Success /> : <Failure />}
    </div>
  );
};
